<template>
  <div>
    <TransitionRoot
      as="template"
      :show="modal.open"
    >
      <Dialog
        class="relative z-50"
        @close="modal.open = false"
      >
        <div class="fixed inset-0" />

        <div class="fixed inset-0 overflow-hidden">
          <div class="absolute inset-0 overflow-hidden">
            <div class="pointer-events-none fixed inset-y-0 right-0 flex max-w-full pl-0 sm:pl-16">
              <TransitionChild
                as="template"
                enter="transform transition ease-in-out duration-500 sm:duration-700"
                enter-from="translate-x-full"
                enter-to="translate-x-0"
                leave="transform transition ease-in-out duration-500 sm:duration-700"
                leave-from="translate-x-0"
                leave-to="translate-x-full"
              >
                <DialogPanel class="pointer-events-auto w-screen sm:max-w-xl">
                  <div class="flex h-full flex-col overflow-y-auto bg-white py-6 shadow-xl">
                    <div class="px-2 sm:px-6">
                      <div class="flex items-start justify-between">
                        <DialogTitle class="text-xl font-semibold text-gray-900">
                          {{ title }}
                        </DialogTitle>
                        <div class="ml-3 flex h-7 items-center">
                          <button
                            type="button"
                            class="relative rounded-md bg-white text-gray-400 hover:text-gray-500 focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-indigo-500 focus-visible:ring-offset-2"
                            @click="modal.open = false"
                          >
                            <span class="absolute -inset-2.5" />
                            <span class="sr-only">Close panel</span>
                            <v-icon-x class="!size-6" />
                          </button>
                        </div>
                      </div>
                    </div>
                    <div class="flex-1 mt-12 overflow-y-auto px-2 sm:px-6">
                      <slot />
                    </div>
                    <div class="px-4 sm:px-6 py-4 flex flex-col justify-between gap-3">
                      <VButtonSecondary
                        class="font-semibold"
                        @click="modal.open = false"
                      >
                        <span>{{ cancelText }}</span>
                      </VButtonSecondary>
                      <VButton
                        class="flex items-center justify-center gap-3 font-semibold active:scale-[0.98] transition-transform duration-200"
                        @click="$emit('confirm', modal?.payload)"
                      >
                        <slot name="icon" />
                        <span>{{ confirmText }}</span>
                      </VButton>
                    </div>
                  </div>
                </DialogPanel>
              </TransitionChild>
            </div>
          </div>
        </div>
      </Dialog>
    </TransitionRoot>
  </div>
</template>

<script setup>
import { inject } from 'vue';
import {
  Dialog, DialogPanel, DialogTitle, TransitionChild, TransitionRoot,
} from '@headlessui/vue';
import VButtonSecondary from '../buttons/VButtonSecondary.vue';
import VButton from '../buttons/VButton.vue';

defineProps({
  title: { type: String, default: '' },
  cancelText: { type: String, default: 'Cancel' },
  confirmText: { type: String, default: 'Confirm' },
});
defineEmits(['confirm']);

const modal = inject('modal');
</script>
